import React, { useState, useEffect } from "react";
import SettingsService from "../../../services/SettingsService";

const SecuritySettings = ({ user, showToast }) => {
  const [sessions, setSessions] = useState([]);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });

  useEffect(() => {
    loadSessions();
  }, []);

  const loadSessions = async () => {
    try {
      const data = await SettingsService.getActiveSessions();
      setSessions(data.sessions || []);
    } catch (error) {
      console.error("Erro ao carregar sessões:", error);
    }
  };

  const handleChangePassword = async () => {
    if (!passwords.current || !passwords.new || !passwords.confirm) {
      showToast("Preencha todos os campos", "error");
      return;
    }

    if (passwords.new !== passwords.confirm) {
      showToast("As senhas não coincidem", "error");
      return;
    }

    try {
      await SettingsService.changePassword(
        passwords.current,
        passwords.new,
        passwords.confirm
      );
      showToast("Senha alterada com sucesso");
      setShowPasswordModal(false);
      setPasswords({ current: "", new: "", confirm: "" });
    } catch (error) {
      showToast(error.message || "Erro ao alterar senha", "error");
    }
  };

  const handleEndSession = async (sessionId) => {
    try {
      await SettingsService.endSession(sessionId);
      showToast("Sessão encerrada");
      loadSessions();
    } catch (error) {
      showToast("Erro ao encerrar sessão", "error");
    }
  };

  return (
    <div>
      <div className="settings-header">
        <h1>Segurança</h1>
        <p>Proteja sua conta e gerencie sessões ativas</p>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">🔐 Senha</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Alterar senha</div>
            <div className="settings-item-description">
              É recomendado alterar sua senha periodicamente
            </div>
          </div>
          <div className="settings-item-control">
            <button
              className="settings-button settings-button-primary"
              onClick={() => setShowPasswordModal(true)}
            >
              Alterar Senha
            </button>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">📱 Sessões Ativas</h3>
        <p className="settings-section-description">
          Gerencie os dispositivos onde sua conta está conectada
        </p>

        {sessions.length === 0 ? (
          <p>Nenhuma sessão ativa encontrada</p>
        ) : (
          sessions.map((session) => (
            <div key={session._id} className="session-card">
              <div className="session-card-header">
                <div className="session-device">
                  {session.device || "Dispositivo Desconhecido"}
                  {session.isActive && (
                    <span className="session-current-badge">Atual</span>
                  )}
                </div>
              </div>
              <div className="session-info">
                <span>🌐 {session.browser || "Navegador desconhecido"}</span>
                <span>📍 {session.location || "Localização desconhecida"}</span>
                <span>
                  🕐 Último acesso:{" "}
                  {new Date(session.lastActiveAt).toLocaleString()}
                </span>
              </div>
              {!session.isActive && (
                <div className="session-actions">
                  <button
                    className="settings-button settings-button-danger"
                    onClick={() => handleEndSession(session._id)}
                  >
                    Encerrar Sessão
                  </button>
                </div>
              )}
            </div>
          ))
        )}

        <button
          className="settings-button settings-button-danger"
          onClick={async () => {
            try {
              await SettingsService.endAllOtherSessions();
              showToast("Todas as outras sessões foram encerradas");
              loadSessions();
            } catch (error) {
              showToast("Erro ao encerrar sessões", "error");
            }
          }}
          style={{ marginTop: "16px" }}
        >
          Encerrar Todas as Outras Sessões
        </button>
      </div>

      {/* Modal de Alteração de Senha */}
      {showPasswordModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowPasswordModal(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Alterar Senha</h2>

            <div className="settings-form-group">
              <label className="settings-form-label">Senha Atual</label>
              <input
                type="password"
                className="settings-input"
                value={passwords.current}
                onChange={(e) =>
                  setPasswords({ ...passwords, current: e.target.value })
                }
                placeholder="Digite sua senha atual"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">Nova Senha</label>
              <input
                type="password"
                className="settings-input"
                value={passwords.new}
                onChange={(e) =>
                  setPasswords({ ...passwords, new: e.target.value })
                }
                placeholder="Digite a nova senha"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">Confirmar Nova Senha</label>
              <input
                type="password"
                className="settings-input"
                value={passwords.confirm}
                onChange={(e) =>
                  setPasswords({ ...passwords, confirm: e.target.value })
                }
                placeholder="Confirme a nova senha"
              />
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                className="settings-button settings-button-secondary"
                onClick={() => setShowPasswordModal(false)}
              >
                Cancelar
              </button>
              <button
                className="settings-button settings-button-primary"
                onClick={handleChangePassword}
              >
                Alterar Senha
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .modal-content {
          background: var(--bg-secondary);
          padding: 30px;
          border-radius: 12px;
          max-width: 500px;
          width: 90%;
        }
      `}</style>
    </div>
  );
};

export default SecuritySettings;
